import { GUID, Param } from "app/brightserve/brightserve.module";

import { Allergy } from "./allergy";
import { Incident } from "./incident";
import { Medication } from "./medication";

export class Person {

    Id: GUID;
    Title: string;
    Name: string;
    Position: string;
    DateOfBirth?: Date;
    Gender: Param;

    EnteredBy: string;
    DateEntered?: Date;

    Medications: Medication[];
    Allergies: Allergy[];
    Incidents: Incident[];

    constructor(init?: Partial<Person>) {
        Object.assign(this, init);

        if (init && init.Gender) {
            this.Gender = new Param(init.Gender);
        } else {
            this.Gender = null;
        };

        if (init && init.Medications) {
            this.Medications = init.Medications.map(m => new Medication(m));
		} else {
            this.Medications = new Array<Medication>()
        };

        if (init && init.Allergies) {
            this.Allergies = init.Allergies.map(m => new Allergy(m));
        } else {
            this.Allergies = new Array<Allergy>()
        };

        if (init && init.Incidents) {
            this.Incidents = init.Incidents.map(m => new Incident(m));
        } else {
            this.Incidents = new Array<Incident>()
        };
    };

    static NewPerson(): any {
        return new Person({ Id: GUID.newGuid(), DateEntered: new Date(), Gender: new Param({ Entity: "Patient", Field: "Gender" }) });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/person.ts